module.exports = __webpack_public_path__ + "img/defaultTarget.4ca56a4a.svg";